angular.module('TetherApp').factory('locationModalService', [
    '$http',
    '$mdDialog',
    '$mdToast',
    function (
        $http,
        $mdDialog,
        $mdToast
    ) {

        let self = this;

        let randomString = function () {
            let result = '';
            let length = 16;
            let chars = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ';
            for (let i = length; i > 0; --i) result += chars[Math.round(Math.random() * (chars.length - 1))];
            return result;
        };

        let getGoogleMapsModal = function(ev, locationId) {
            return $mdDialog.show({
                controller: LocationModalController,
                controllerAs: 'locationModalController',
                templateUrl: '/location/' + locationId + '/google-maps-modal',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                escapeToClose: true
            });
        };

        let LocationModalController = function ($mdDialog) {
            let dCtrl = this;

            dCtrl.hide = function () {
                $mdDialog.hide();
            };

            dCtrl.cancel = function () {
                $mdDialog.cancel();
            };
        };

        let getAllCampaignLocationsGoogleMapsModal = function(ev, campaignId) {
            return $mdDialog.show({
                controller: LocationModalController,
                controllerAs: 'locationModalController',
                templateUrl: '/campaign/' + campaignId + '/all-campaign-locations-google-maps-modal',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                escapeToClose: true
            });
        };

        return {
            getGoogleMapsModal: getGoogleMapsModal,
            getAllCampaignLocationsGoogleMapsModal: getAllCampaignLocationsGoogleMapsModal
        }

    }
]);
